import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/firestore';
import { Params } from "../../pages/params";
import { Http } from "@angular/http";
import { Events } from 'ionic-angular';
import { environment } from "../../environments/environment";

/*
  Generated class for the GlobalProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class GlobalProvider {
  public customers = {};
  public foods = [];
  public ingredients = [];
  public gingredients = [];
  public recipes = [];
  constructor(public http: Http, public events: Events) {
    console.log('Hello GlobalProvider Provider');
    this.getCustomers();
    this.getFoods();
    this.getIngredients();
    this.getGIngredients();
    this.getRecipes();

    firebase.database().ref('/customers')
      .on('value', (snap) => {
        this.customers = snap.val();
      });
  }

  private getIngredients() {
    this.http.post('https://irp-system.web.app/resolveIngredients', {
      'company': 'NeozyuxJrPPNiwkwiPfy',
      'week': 1
    }).subscribe((resp) => {
      this.ingredients = resp.json().data;
    })
  }

  private getGIngredients() {
    this.http.post('https://irp-system.web.app/resolveGroupsIngredients', {
      'company': 'NeozyuxJrPPNiwkwiPfy',
      'week': 1
    }).subscribe((resp) => {
      this.gingredients = resp.json().data;
    })
  }

  private getRecipes() {
    this.http.post(environment.urlIRPService + '/resolveRecipes', {
      company: "NeozyuxJrPPNiwkwiPfy"
    }).subscribe((resp) => {
      console.log("recipes ok", resp.json());
      if (resp.json().ok) {
        this.recipes = resp.json().data;
        this.events.publish("foods:ready");
      }
    },
      (err) => {
        console.log("error get recipes", err);
      }
    );
  }

  private getFoods() {
    this.http
      .post("https://irp-system.web.app/foods", {
        company: "NeozyuxJrPPNiwkwiPfy",
        week: 1,
      })
      .subscribe((resp) => {
        const irp_foods = resp.json().config.product_subfamilies; // .filter((x)=>x.active);
        firebase
          .firestore()
          .collection("foods")
          .get()
          .then((snap) => {
            if (!snap.empty) {
              const sys_foods = {};
              snap.forEach((x) => (sys_foods[x.id] = x.data().price));
              irp_foods.map((food) => {
                food.price = sys_foods[food.value];
                return food;
              });

              this.foods = irp_foods;
              console.log(this.foods);
            }
          });
      });
  }

  private getCustomers() {
    firebase
      .database()
      .ref("/customers")
      .once("value")
      .then((snap) => {
        this.customers = snap.val();
        console.log("customers ok");
      });
  }

  existsCustomer(cust, md5) {
    let customer = cust;
    if (!md5) customer = Params.md5(cust);
    if (this.customers[customer]) {
      if (this.customers[customer].active) {
        return {
          type: 2,
          customer,
          name:
            this.customers[customer].name +
            " " +
            this.customers[customer].lastname,
          email: this.customers[customer].email,
        };
      } else {
        return {
          type: 3,
          customer,
          name:
            this.customers[customer].name +
            " " +
            this.customers[customer].lastname,
          email: this.customers[customer].email,
        };
      }
    } else {
      return { type: 1, name: null };
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/global/global.ts